import React from "react";

const NotificationContext = React.createContext();
NotificationContext.displayName = "AlertContext";

export default NotificationContext;
